<template>
	<div>
		<!-- 面包屑导航区域 -->		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 -->
			<div style="margin-bottom: 20px;">
				<el-form ref="simInfoPageInfoReq" :model="simInfoPageInfoReq" inline label-width="70px" size="small">
					<el-form-item label="ICCID:">
						<el-input :clearable=true v-model="simInfoPageInfoReq.iccid" placeholder="请输入ICCID"
							style="width: 180px;" />
					</el-form-item>
					<el-form-item label="状态:">
						<el-select v-model="simInfoPageInfoReq.status" placeholder="请选择" clearable
							style="width: 120px;">
							<el-option v-for="item in statusOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="运营商:">
						<el-select v-model="simInfoPageInfoReq.distributorId" placeholder="请选择" clearable filterable
							style="width: 120px;">
							<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" style="margin-left: 10px;" @click="initSimInfo()">+ 添加SIM卡</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="warning" style="margin-left: 8px;" @click="batchUpdateTime()" :disabled="selectedRows.length === 0">批量修改时间</el-button>
					</el-form-item>
					<!-- <el-form-item>
						<el-button type="danger" style="margin-left: 8px;" @click="batchDelete">批量删除</el-button>
					</el-form-item> -->

					<el-form-item>
						<el-button type="primary" style="margin-left: 10px;" @click="reGetSimInfoList()">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!-- SIM卡列表区域 -->
			<el-table :data="simInfoList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }" ref="simInfoTable" style="width: 100%;" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column label="运营商" prop="distributorName" width="230px">
				</el-table-column>
				<el-table-column label="ICCID" prop="iccid" width="170px"></el-table-column>
				<el-table-column label="IMEI" prop="imei" width="130px"></el-table-column>
				<el-table-column label="状态" prop="status"">
					<template slot-scope="scope">
						{{ scope.row.status == 1 ? '正常' : (scope.row.status == 2 ? '离线' : '无法识别') }}
					</template>
				</el-table-column>
				<el-table-column label="开始时间" prop="startTime"">
					<template slot-scope="scope">
						{{ formatDate(scope.row.startTime) }}
					</template>
				</el-table-column>
				<el-table-column label="实际到期时间" prop="endTime"">
					<template slot-scope="scope">
						{{ formatDate(scope.row.endTime) }}
					</template>
				</el-table-column>
				<el-table-column label="运营商到期时间" prop="distributorEndTime"">
					<template slot-scope="scope">
						{{ formatDate(scope.row.distributorEndTime) }}
					</template>
				</el-table-column>
				<el-table-column label="卡商" prop="simType">
					<template slot-scope="scope">
						{{ getSimTypeName(scope.row.simType) }}
					</template>
				</el-table-column>
				<el-table-column label="更新时间" prop="updateTime" width="150px"></el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="180" label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="el-icon-edit"
							@click="updateSimInfoInit(scope.row.id)">编辑</el-button>
						<el-button size="mini" type="danger" icon="el-icon-delete"
							@click="deleteSimInfo(scope.row.id, scope.row.imei)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="simInfoPageInfoReq.page" :page-sizes="[8, 15, 25, 50, 100]"
				:page-size="simInfoPageInfoReq.limit" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>

			<!-- SIM卡信息修改 -->
			<el-dialog title="修改SIM卡信息" :visible.sync="updateSimInfoDialogVisible" width="800px">
				<el-form :model="simInfo" status-icon :rules="simInfoRules" ref="simInfoUpdate" label-width="100px"
					class="demo-ruleForm" style="padding-right: 50px;">
					<el-col :span="12">
						<el-form-item label="ICCID:" prop="iccid">
							<el-input v-model.trim="simInfo.iccid" type="text" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="IMEI:" prop="imei">
							<el-input v-model.trim="simInfo.imei" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="卡商:" prop="simType">
							<el-select :clearable=true v-model="simInfo.simType" :filterable=true placeholder="请选择">
								<el-option v-for="item in simTypeOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="状态:" prop="status">
							<el-select :clearable=true v-model="simInfo.status" :filterable=true placeholder="请选择">
								<el-option v-for="item in statusOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="开始时间:" prop="startTime">
							<el-date-picker type="date" v-model="simInfo.startTime" placeholder="选择日期"
								value-format="yyyy-MM-dd" class="date-picker-custom"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="到期时间:" prop="endTime">
							<el-date-picker type="date" v-model="simInfo.endTime" placeholder="选择日期"
								value-format="yyyy-MM-dd" class="date-picker-custom"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="运营商到期时间:" prop="distributorEndTime">
							<el-date-picker type="date" v-model="simInfo.distributorEndTime" placeholder="选择日期"
								value-format="yyyy-MM-dd" class="date-picker-custom"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="updateSimInfoDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="updateSimInfo()">确 定
					</el-button>
				</span>
			</el-dialog>

			<!-- SIM卡信息添加 -->
			<el-dialog title="添加SIM卡信息" :visible.sync="addSimInfoDialogVisible" width="800px">
				<el-form :model="simInfo" status-icon :rules="simInfoRules" ref="simInfoAdd" label-width="100px"
					class="demo-ruleForm" style="padding-right: 50px;">
					<el-col :span="12">
						<el-form-item label="ICCID:" prop="iccid">
							<el-input v-model.trim="simInfo.iccid" type="text" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="IMEI:" prop="imei">
							<el-input v-model.trim="simInfo.imei" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="运营商:" prop="distributorId">
							<el-select v-model="simInfo.distributorId" placeholder="请选择" clearable filterable
								@change="handleDistributorChange">
								<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="状态:" prop="status">
							<el-select :clearable=true v-model="simInfo.status" :filterable=true placeholder="请选择">
								<el-option v-for="item in statusOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="开始时间:" prop="startTime">
							<el-date-picker type="date" v-model="simInfo.startTime" placeholder="选择日期"
								value-format="yyyy-MM-dd" class="date-picker-custom"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="到期时间:" prop="endTime">
							<el-date-picker type="date" v-model="simInfo.endTime" placeholder="选择日期"
								value-format="yyyy-MM-dd" class="date-picker-custom"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="运营商到期时间:" prop="distributorEndTime">
							<el-date-picker type="date" v-model="simInfo.distributorEndTime" placeholder="选择日期"
								value-format="yyyy-MM-dd" class="date-picker-custom"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addSimInfoDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="addSimInfo()">确 定
					</el-button>
				</span>
			</el-dialog>

			<!-- 批量修改时间 -->
			<el-dialog title="批量修改时间" :visible.sync="batchUpdateTimeDialogVisible" width="700px">
				<el-alert :title="`已选择 ${selectedRows.length} 条SIM卡记录`" type="info" :closable="false" style="margin-bottom: 20px;"></el-alert>
				<el-form :model="batchUpdateTimeForm" status-icon :rules="batchUpdateTimeRules" ref="batchUpdateTimeForm" label-width="140px"
					class="demo-ruleForm" style="padding-right: 20px;">
					<el-form-item label="批量修改类型:" prop="updateType">
						<el-radio-group v-model="batchUpdateTimeForm.updateType">
							<el-radio label="startTime">开始时间</el-radio>
							<el-radio label="endTime">实际到期时间</el-radio>
							<el-radio label="distributorEndTime">运营商到期时间</el-radio>
							<el-radio label="all">全部时间</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="batchUpdateTimeForm.updateType === 'startTime' || batchUpdateTimeForm.updateType === 'all'" label="开始时间:" prop="startTime">
						<el-date-picker type="date" v-model="batchUpdateTimeForm.startTime" placeholder="选择开始时间"
							value-format="yyyy-MM-dd" class="date-picker-custom" style="width: 100%;"></el-date-picker>
					</el-form-item>
					<el-form-item v-if="batchUpdateTimeForm.updateType === 'endTime' || batchUpdateTimeForm.updateType === 'all'" label="实际到期时间:" prop="endTime">
						<el-date-picker type="date" v-model="batchUpdateTimeForm.endTime" placeholder="选择实际到期时间"
							value-format="yyyy-MM-dd" class="date-picker-custom" style="width: 100%;"></el-date-picker>
					</el-form-item>
					<el-form-item v-if="batchUpdateTimeForm.updateType === 'distributorEndTime' || batchUpdateTimeForm.updateType === 'all'" label="运营商到期时间:" prop="distributorEndTime">
						<el-date-picker type="date" v-model="batchUpdateTimeForm.distributorEndTime" placeholder="选择运营商到期时间"
							value-format="yyyy-MM-dd" class="date-picker-custom" style="width: 100%;"></el-date-picker>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchUpdateTimeDialogVisible = false">取 消</el-button>
					<el-button type="warning" @click="confirmBatchUpdateTime()">确 定</el-button>
				</span>
			</el-dialog>

		</el-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			user: '',
			simInfoPageInfoReq: {
				//当前页数
				page: 1,
				//当前每页多少条
				limit: 8,
				iccid: '',
				status: '',
				distributorId: ''
			},
			simInfoList: [],
			total: 0,
			statusOptions: [{
				key: 1,
				value: '正常'
			}, {
				key: 2,
				value: '离线'
			}],
			simTypeOptions: [],
			distributorOptions: [],
			// SIM卡信息修改弹框
			updateSimInfoDialogVisible: false,
			addSimInfoDialogVisible: false,
			updateStatusDialogVisible: false,
			simInfo: {},
			updateStatusForm: {
				status: ''
			},
			selectedIds: [],
			currentSimId: null,
			simInfoRules: {
				iccid: [{
					required: true,
					message: '请输入ICCID',
					trigger: ['blur', 'change'],
				}, {
					min: 1,
					max: 100,
					message: '长度在 1 到 100 个字符',
					trigger: ['blur', 'change'],
				}]
			},
			updateStatusRules: {
				status: [{
					required: true,
					message: '请选择状态',
					trigger: ['blur', 'change'],
				}]
			},
			// 批量修改时间相关
			batchUpdateTimeDialogVisible: false,
			selectedRows: [],
			batchUpdateTimeForm: {
				updateType: 'startTime',
				startTime: '',
				endTime: '',
				distributorEndTime: ''
			},
			batchUpdateTimeRules: {
				updateType: [{
					required: true,
					message: '请选择修改类型',
					trigger: ['blur', 'change'],
				}],
				startTime: [{
					required: true,
					message: '请选择开始时间',
					trigger: ['blur', 'change'],
				}],
				endTime: [{
					required: true,
					message: '请选择实际到期时间',
					trigger: ['blur', 'change'],
				}],
				distributorEndTime: [{
					required: true,
					message: '请选择运营商到期时间',
					trigger: ['blur', 'change'],
				}]
			}
		};
	},
	created() {
			this.user = window.sessionStorage.getItem('user');
			this.getSimInfoList();
			this.getDistributorList();
			this.getSimCardMerchantList();
		},
	watch: {
		// 监听表格选中项变化
		'simInfoList'(newVal) {
			this.selectedIds = [];
		}
	},
	methods: {
		// 格式化日期，只显示年月日
		formatDate(dateStr) {
			if (!dateStr) return '';
			// 如果日期包含时间部分，只取日期部分
			return dateStr.split(' ')[0];
		},




		async getSimInfoList() {
			const { data: res } = await this.$http.post('/sim/manager/list', this.simInfoPageInfoReq);
			if (res.code != 200) return this.$message.error(res.msg);
			this.simInfoList = res.data.list;
			this.total = res.data.total;
		},
		reGetSimInfoList() {
				this.simInfoPageInfoReq.page = 1;
				this.getSimInfoList();
			},
		//监听pagesize变化
		handleSizeChange(limit) {
				this.simInfoPageInfoReq.limit = limit;
				this.getSimInfoList();
			},
		//监听页数变化
		handleCurrentChange(page) {
				this.simInfoPageInfoReq.page = page;
				this.getSimInfoList();
			},
		async updateSimInfoInit(id) {
			const { data: res } = await this.$http.get('/sim/manager/getSimInfoById/' + id);
			if (res.code != 200) return this.$message.error(res.msg);

			// 处理日期格式，将ISO格式（带T）转换为普通格式（不带T）
			const simInfoData = res.data;
			if (simInfoData.startTime && simInfoData.startTime.includes('T')) {
				simInfoData.startTime = simInfoData.startTime.replace('T', ' ');
			}
			if (simInfoData.endTime && simInfoData.endTime.includes('T')) {
				simInfoData.endTime = simInfoData.endTime.replace('T', ' ');
			}
			if (simInfoData.distributorEndTime && simInfoData.distributorEndTime.includes('T')) {
				simInfoData.distributorEndTime = simInfoData.distributorEndTime.replace('T', ' ');
			}

			this.simInfo = simInfoData;
			this.updateSimInfoDialogVisible = true;
		},
		updateSimInfo() {
			this.$refs.simInfoUpdate.validate((valid) => {
				if (valid) {
					const simInfoData = { ...this.simInfo };

					this.$http.post('/sim/manager/update', simInfoData).then((res) => {
						if (res.data.code != 200) return this.$message.error(res.data.msg);
						this.updateSimInfoDialogVisible = false;
						this.reGetSimInfoList();
						this.$message.success(res.data.msg);
					});
				} else {
					return false;
				}
			});
		},
		async initSimInfo() {
			// 初始化simInfo对象，确保日期字段为空
			this.simInfo = {
				iccid: '',
				imsi: '',
				imei: '',
				cardBalance: '',
				flowPackage: '',
				flowOverlay: '',
				status: '',
				qrNumber: '',
				distributorId: '',
				distributorName: '', // 确保清空运营商名称
				simType: '',
				startTime: '',
				endTime: '',
				distributorEndTime: ''
			};
			this.addSimInfoDialogVisible = true;
		},
		addSimInfo() {
			this.$refs.simInfoAdd.validate((valid) => {
				if (valid) {
					const simInfoData = { ...this.simInfo };

					this.$http.post('/sim/manager/add', simInfoData).then((res) => {
						if (res.data.code != 200) return this.$message.error(res.data.msg);
						this.addSimInfoDialogVisible = false;
						this.reGetSimInfoList();
						this.$message.success(res.data.msg);
					});
				} else {
					return false;
				}
			});
		},
		deleteSimInfo(id, imei) {
			this.$confirm("确认删除IMEI号为 " + imei + " 的SIM卡数据吗？", {
				title: "提示",
				type: 'warning',
			}).then(resc => {
				this.$http.post('/sim/manager/delete/' + id).then((res) => {
					if (res.data.code != 200) return this.$message.error(res.data.msg);
					this.reGetSimInfoList();
					this.$message.success(res.data.msg);
				});
			});
		},
		// 获取运营商列表
		getDistributorList() {
			this.$http.get('distributor/manager/getAllDistributorInfo').then((res) => {
				this.distributorOptions = [];
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				let distributorInfoList = res.data.data;
				for (let index in distributorInfoList) {
					this.distributorOptions.push({ key: distributorInfoList[index].id, value: distributorInfoList[index].name });
				}
			});
		},
		
		// 获取卡商列表
		getSimCardMerchantList() {
			this.$http.get('/sim/manager/getAllSimCardMerchantList').then((res) => {
				this.simTypeOptions = [];
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				let merchantList = res.data.data;
				for (let index in merchantList) {
					this.simTypeOptions.push({ key: merchantList[index].k, value: merchantList[index].v });
				}
			});
		},
		
		// 根据卡商ID获取卡商名称
		getSimTypeName(simType) {
			const item = this.simTypeOptions.find(option => option.key === simType);
			return item ? item.value : '未知卡商';
		},

		// 处理运营商选择变化
		handleDistributorChange(distributorId) {
			if (distributorId) {
				const selectedDistributor = this.distributorOptions.find(item => item.key === distributorId);
				if (selectedDistributor) {
					this.simInfo.distributorName = selectedDistributor.value;
				}
			} else {
				this.simInfo.distributorName = '';
			}
		},

		// 处理表格选择变化
		handleSelectionChange(selection) {
			this.selectedRows = selection;
		},
		// 批量修改时间
		batchUpdateTime() {
			if (this.selectedRows.length === 0) {
				return this.$message.error('请选择要修改的SIM卡记录');
			}
			// 重置表单
			this.batchUpdateTimeForm = {
				updateType: 'startTime',
				startTime: '',
				endTime: '',
				distributorEndTime: ''
			};
			this.batchUpdateTimeDialogVisible = true;
		},
		// 确认批量修改时间
		confirmBatchUpdateTime() {
			this.$refs.batchUpdateTimeForm.validate((valid) => {
				if (valid) {
					const selectedIds = this.selectedRows.map(row => row.id);
					const updateData = {
						ids: selectedIds,
						updateType: this.batchUpdateTimeForm.updateType
					};
					
					// 根据更新类型添加相应的时间字段
					if (this.batchUpdateTimeForm.updateType === 'startTime' || this.batchUpdateTimeForm.updateType === 'all') {
						updateData.startTime = this.batchUpdateTimeForm.startTime;
					}
					if (this.batchUpdateTimeForm.updateType === 'endTime' || this.batchUpdateTimeForm.updateType === 'all') {
						updateData.endTime = this.batchUpdateTimeForm.endTime;
					}
					if (this.batchUpdateTimeForm.updateType === 'distributorEndTime' || this.batchUpdateTimeForm.updateType === 'all') {
						updateData.distributorEndTime = this.batchUpdateTimeForm.distributorEndTime;
					}
					
					this.$http.post('/sim/manager/batchUpdateTime', updateData).then((res) => {
						if (res.data.code != 200) return this.$message.error(res.data.msg);
						this.batchUpdateTimeDialogVisible = false;
						this.reGetSimInfoList();
						this.$message.success(`成功更新 ${this.selectedRows.length} 条SIM卡记录的时间信息`);
					}).catch(err => {
						console.error('批量修改时间失败:', err);
						this.$message.error('批量修改时间失败，请稍后重试');
					});
				} else {
					return false;
				}
			});
		},
		// 批量删除
			batchDelete() {
				const selectedRows = this.$refs.simInfoTable.selection;
				if (!selectedRows || selectedRows.length === 0) {
					return this.$message.error('请选择要删除的SIM卡');
				}
				this.selectedIds = selectedRows.map(row => row.id);
				this.$confirm(`确认删除选中的 ${selectedRows.length} 条SIM卡数据吗？`, {
					title: "提示",
					type: 'warning',
				}).then(resc => {
					this.$http.post('/sim/manager/batchDelete', this.selectedIds).then((res) => {
						if (res.data.code != 200) return this.$message.error(res.data.msg);
						this.reGetSimInfoList();
						this.$message.success(res.data.msg);
					});
				});
		}
	}
};
</script>

<style scoped>
.date-picker-custom {
	width: 100%;
}

/* 解决日期选择器图标与文本重叠的问题 */
.el-date-editor.el-input {
	width: 100%;
}

.el-date-editor .el-input__inner {
	padding-right: 30px;
}

.el-date-editor .el-input__prefix {
	right: 5px;
	left: auto;
}
</style>